/** Renderiza conteúdo destacando menções @nome */
export function CommentContent({ content }: { content: string }) {
  const parts = content.split(/(@[^\s@]+)/g);

  return (
    <>
      {parts.map((part, index) => {
        if (part.startsWith('@')) {
          return (
            <span
              key={`mention-${index}`}
              className="rounded bg-primary/10 px-0.5 font-medium text-primary"
            >
              {part}
            </span>
          );
        }
        return <span key={`text-${index}`}>{part}</span>;
      })}
    </>
  );
}
